import { Avatar } from "@mui/material";

const PlayerAvatar = ({ name, imageUrl, size = "md" }) => {
  // const sizeClasses = {
  //   sm: "w-6 h-6",
  //   md: "w-8 h-8 md:w-10 md:h-10",
  //   lg: "w-10 h-10 md:w-12 md:h-12",
  //   xl: "w-12 h-12 md:w-16 md:h-16",
  // };

  return (
    <Avatar
      className={`!w-12 !h-12 md:!w-[70px] md:!h-[70px] border-2 border-white shadow-md !absolute -top-10 left-1/2 -translate-x-1/2`}
      src={imageUrl}
      alt={name}
    />
  );
};

export default PlayerAvatar;
